<div class="loading-overlay">
    <div class="astronaut-wrapper">
        <i class="fas fa-user-astronaut astronaut-icon"></i>
        <div class="astronaut-shadow"></div>
    </div>
    <div class="loading-text">Cargando Sistema...</div>
</div>